module.exports = __webpack_public_path__ + "img/xlph1.f1651957.jpg";